import { Theme, css } from '@emotion/react';

export const tabsRoot =
  (isContained?: boolean) =>
  ({ colors }: Theme) => css`
    .MuiTabs-scroller {
      border-bottom: ${isContained ? `1px solid ${colors.borderDefault}` : 0};
    }

    .MuiTabs-indicator {
      height: 2px;
    }
  `;
